import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Image, theme, webOnlyStyles } from '@sg/garnish';

export const HomeHeroImageSM = (props: HomeHeroImageSMProps) => {
  const { imageUrl, imageA11yLabel, dataSet } = props;

  return (
    <View style={styles.heroImageWrapper} {...(dataSet ? { dataSet } : {})}>
      <Image
        contentFit="cover"
        style={[styles.heroImage, webOnlyStyles({ width: '50vw' } as never)]}
        aria-label={imageA11yLabel}
        source={imageUrl}
      />
    </View>
  );
};

export const HomeHeroImagePlaceholderSM = () => {
  return <View style={styles.heroImagePlaceholder} />;
};

const styles = StyleSheet.create({
  heroImageWrapper: {
    flex: 0,
    position: 'relative',
    borderLeftWidth: 1,
    borderLeftColor: theme.colors.DARK_KALE,
  },
  heroImage: {
    position: 'absolute',
    height: '100%',
    width: 720,
    minHeight: 480,
    left: 0,
  },
  heroImagePlaceholder: {
    flex: 1,
    height: '100%',
    minHeight: 480,
  },
});

type HomeHeroImageSMProps = {
  imageUrl: string;
  imageA11yLabel: string;
  dataSet?: Record<string, string>;
};
